export default {
    methods: {
      /*
        dateString is in the format provided by back-end which is
        "HH:mm dd/MM/yyyy"
      */
      getDateValue(dateString) {
        const day = parseInt(dateString.substring(6, 8));
        const month = parseInt(dateString.substring(9, 11)) - 1;
        const year = parseInt(dateString.substring(12, 17));
        const hour = parseInt(dateString.substring(0, 2));
        const minute = parseInt(dateString.substring(3, 5));

        var dateObj = new Date(year, month, day, hour, minute, 0);
        return dateObj;
      },
      getTrackingAge(newThreshold, useNetworkEntryTimestamp) {
        let trackingDate;
        if (useNetworkEntryTimestamp) {
          if (this.$store.state.tracking.networkEntryTimestamp == '') {
            return "NEW";
          }
          trackingDate = this.getDateValue(this.$store.state.tracking.networkEntryTimestamp);
        } else {
          trackingDate = this.getDateValue(this.$store.state.tracking.dateTime);
        }
        const now = new Date();

        const diff = (now - trackingDate) /  (1000 * 60 * 60 * 24);
        console.log(`getTrackingAge: date: ${trackingDate}, now: ${now}, diff: ${diff}`);

        if (diff <= newThreshold) {
          return "NEW";
        }

        if (diff <= 30) {
          return "MEDIUM";
        }

        return "TOO_OLD";
      },
      isReturnBarcode() {
        return this.$store.state.tracking &&
          this.$store.state.tracking.barcode && (
            this.$store.state.tracking.barcode.charAt(5) == 'D' ||
            this.$store.state.tracking.barcode.charAt(5) == 'E' ||
            this.$store.state.tracking.barcode.substring(0,2) == '34'
          );
      },
      getTrackingOverride() {
        return this.$store.state.overrideTracking;
      }
    }
}



// WEBPACK FOOTER //
// ./src/components/helpers/tracking.js